import React from "react";
import {useHistory} from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import {makeStyles, Tooltip} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {loginClient} from "@cabinet-packages/redux";
import {AccessKey} from "@cabinet-packages/helpers";
import themeMaterialUI from "../../settings/themeMaterialUI";

const useStyles = makeStyles((theme) => ({
        header: {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            borderRadius: '0 0 25px 25px',
            '@media (max-width: 950px)': {
                flexDirection: 'row',
                justifyContent: 'center',
                paddingRight: '0px',
                width: '100%',
            },
        },
        headerWrapper: {
            display: 'flex',
            position: 'relative',
            flexDirection: 'row',
            justifyContent: 'center',
            height: '82px',
            '@media (max-width: 950px)': {
                padding: '5px',
                width: '100%',
                height: '100%',
            },
        },
        headerLogoWrapper: {
            '@media (max-width: 950px)': {
                width: '100%',
                marginLeft: '5px',
            },
        },
        headerLogoButton: {
            padding: 0,
            cursor: 'pointer',
        },
        headerLogo: {
            maxWidth: '144px',
            maxHeight: '64px',
            margin: '8px',
            '@media (max-width: 950px)': {
                width: '60%',
            },
        },
        headingText: {
            color: theme.palette.primary.main,
            textAlign: 'center'
        },
}));

const Header = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const { activePatient } = useSelector(state => state.patients);
    const accessKeyFromCookies = AccessKey.get();

    const handleClickOnAccount = () => {
        activePatient && accessKeyFromCookies
            ? history.push('/account-settings')
            : dispatch(loginClient(themeMaterialUI, history))
    };

    return (
        <div className={classes.header}>
            <div className={classes.headerWrapper}>
                <div className={classes.headerLogoWrapper}>
                    <div
                        className={classes.headerLogoButton}
                        onClick={handleClickOnAccount}
                    >
                        <Tooltip
                            title={accessKeyFromCookies && activePatient
                                ? "Натисніть щоб перейти в особистий кабінет."
                                : "Натисніть щоб виконати ВХІД / РЕЄСТРАЦІЮ."
                            }
                            arrow
                        >
                            <img
                                src={logo}
                                className={classes.headerLogo}
                                alt="Ваші результати"
                            />
                        </Tooltip>
                    </div>
                </div>
            </div>
            <h1 className={classes.headingText}>Кабінет пацієнта</h1>
        </div>
    );
};

export default Header;
